import apiClient from './apiClient';

// In-memory cache for genres — this data rarely changes but is fetched on
// every page load (library, search, homepage sidebar). A 5-minute TTL keeps
// it fresh while eliminating redundant API calls within a session.
const GENRES_CACHE_TTL_MS = 5 * 60 * 1000;
let genresCache = null;
let genresCacheTimestamp = 0;

export const getGenres = async () => {
  const now = Date.now();
  if (genresCache && (now - genresCacheTimestamp) < GENRES_CACHE_TTL_MS) {
    return genresCache;
  }
  const response = await apiClient.get('/api/genres');
  genresCache = response.data;
  genresCacheTimestamp = now;
  return response.data;
};

// Test helper — clears the in-memory cache so tests start with a clean state.
export const _clearGenresCache = () => {
  genresCache = null;
  genresCacheTimestamp = 0;
};

export const getGenreBySlug = async (slug) => {
  const response = await apiClient.get(`/api/genres/slug/${slug}`);
  return response.data;
};

export const getNovelsByGenreId = async (id, { page = 0, size = 20 } = {}) => {
  const response = await apiClient.get(`/api/genres/${id}/novels`, {
    params: { page, size },
  });
  return response.data;
};

export const createGenre = async (payload) => {
  const response = await apiClient.post('/api/genres', payload);
  return response.data;
};

export const updateGenre = async (id, payload) => {
  const response = await apiClient.put(`/api/genres/${id}`, payload);
  return response.data;
};

export const deleteGenre = async (id) => {
  await apiClient.delete(`/api/genres/${id}`);
};

// Admin-only: merge source genre into target genre
export const mergeGenres = async (sourceId, targetId) => {
  const response = await apiClient.post('/api/genres/merge', null, {
    params: { sourceId, targetId },
  });
  return response.data;
};
